import React, { useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { jsx } from 'react/jsx-runtime';
import { generatePath, useNavigate } from 'react-router';

/* eslint-disable react/jsx-props-no-spreading */
const RoutesContext = /*#__PURE__*/React.createContext(null);
const useRoutesContext = () => useContext(RoutesContext);
const propTypes = {
  children: PropTypes.node.isRequired,
  routes: PropTypes.objectOf(PropTypes.string).isRequired,
  basePath: PropTypes.string
};
const defaultProps = {
  basePath: null
};
function RoutesProvider(_ref) {
  let {
    routes,
    basePath,
    children
  } = _ref;
  const value = useMemo(() => ({
    routes,
    basePath
  }), [routes, basePath]);
  return /*#__PURE__*/jsx(RoutesContext.Provider, {
    value: value,
    children: children
  });
}
RoutesProvider.propTypes = propTypes;
RoutesProvider.defaultProps = defaultProps;

const useUrlGenerator = () => {
  const {
    routes,
    basePath
  } = useRoutesContext();
  const urlGenerator = useCallback((key, data) => {
    const finalKey = key;
    const url = generatePath(routes[finalKey], data);
    return basePath !== null ? "".concat(basePath.replace(/\/$/, ''), "/").concat(url.replace(/^\//, '')) : url;
  }, [routes, basePath]);
  return urlGenerator;
};

const useRouteNavigate = () => {
  const url = useUrlGenerator();
  const navigate = useNavigate();
  const routeNavigate = useCallback(function (route, data) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return navigate(url(route, data), ...args);
  }, [navigate, url]);
  return routeNavigate;
};

const useRoutes = () => {
  const {
    routes
  } = useRoutesContext();
  return routes;
};

export { RoutesContext, RoutesProvider, useRouteNavigate, useRoutes, useRoutesContext, useUrlGenerator };
